<template>
  <!-- <transition-group
    name="fade"
    class="home-view is-grid"
    tag="div"
    v-bind:css="false"
    v-on:before-enter="beforeEnter"
    v-on:enter="enter"
    v-on:leave="leave"
  > -->
  <div class="home-view is-grid">
    <b-user-badge
      v-for="(user, index) in users"
      :key="user.image"
      :class="[{
        'is-col-6': (index + 1) % 3 !== 0,
        'is-col-12': (index + 1) % 3 === 0,
      }]"
      :user="user"
    ></b-user-badge>
  <!-- </transition-group> -->
  </div>
</template>

<script>
  import users from '@assets/data/users'
  import anime from 'animejs'

  export default {
    setup () {
      function beforeEnter (el) {
        console.log(`BEFORE`)
        el.style.opacity = 0
        el.style.height = 0
      }
      
      function enter (el, done) {
        console.log(`ENTER`)
        anime({
          opacity: [0, 1],
          delay: parseInt(el.dataset.index) * 150,
          complete: done
        })
      }
      
      function leave (el, done) {
        console.log(`LEAVE`)
        anime({
          opacity: [1, 0],
          delay: parseInt(el.dataset.index) * 150,
          complete: done
        })
      }

      return {
        beforeEnter,
        enter,
        leave,
        users: users.filter(user => 
          !(/^beno/i).test(user.name)
        ),
      }
    },
  }
</script>

<style lang="scss">
  .home-view {
    // padding: 5px;
  }
</style>